import { Token, TokenType } from ".";
import { LinePosition } from "@wittongue/editor";
export class DeclareVariableToken extends Token {
  constructor(linePosition: LinePosition) {
    super("declare", TokenType.NEW_VARIABLE, linePosition);
  }
}
